<template>
    <Page :header="header[lang].title" type="gray">
        <template v-slot:body>
            <div class="w-full flex flex-column gap-3">
                
                <WalletList
                    v-for="group in groupedWallets"
                    :key="group.group"
                    v-if="groupedWallets.length"
                    :items="[]"
                    colorType="white"
                    :footerTxt="getGroupTotal(group)"
                >
                    <template v-slot:body>
                        <div v-for="(w, index) in group.items" :key="index" 
                            class="w-full flex flex-column1 px-3 py-2 border-200 border-bottom-1 gap-2 hover:surface-100 cursor-pointer" style="min-height:50px" @click="toWallet(w.id)">
                            
                            <div class="w-full flex justify-content-start align-items-center gap-2">
                                <div class="flex justify-content-start align-items-center gap-2">
                                    <span class="text-600">{{ w.description }}</span>
                                </div>
                                <Tag v-if="w.ext_type" :value="GetWalletNameByLabel(w.ext_type)" severity="secondary" class="text-xs hidden xl:flex lg:flex md:flex"/>
                            </div>

                            <div class="w-full flex gap-1 flex-column">
                                <div v-if="w.account_details && w.account_details.length > 0" 
                                    v-for="(a, accIndex) in w.account_details" :key="accIndex"
                                    class="flex">
                                    <div v-if="a && a.balance" class="w-full flex justify-content-start align-items-center p-2 border-round-lg gap-1">
                                        <AvatarGroup v-if="a.network || a.currency" :max="2" class="gap-1">
                                            <Avatar v-if="a.currency" :image="getCurImage(a.currency)" class="surface-0" shape="circle" style="width:20px!important;height:20px!important;"/>
                                            <Avatar v-if="a.network" :image="getNetworkImage(a.network)" class="surface-0" shape="circle" style="width:20px!important;height:20px!important;"/>
                                        </AvatarGroup>
                                        <span class="text-sm font-medium white-space-nowrap">{{ get_format_amount(a.balance, a.currency) }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="flex justify-content-right align-items-center">
                                <i class="text-blue-500 ml-2 pi pi-chevron-right" />
                            </div>
                        </div>
                    </template>
                </WalletList>
                <Skeleton v-if="loading" width="100%" height="50px" class="mb-2" />
            </div>
        </template> 
    </Page>
</template>

<script>
import Connect          from '@/assets/js/Connect'
import Helper           from '@/assets/js/Helper'
import BigNumber        from 'bignumber.js'
import { mapActions }   from 'vuex'
import WalletList          from '@/components/widgets/wallet_list.vue'
import Page             from '@/components/sides/Page.vue' 

export default {
    data() {
        return {
            header: {
                en: {title: "Balances"} ,
                ru: {title: "Балансы"} ,
            },
            wallets: [],
            loading: false,
        }
    },
    components: {
        WalletList,
        Page
    },  
    watch : {
        active: function (val) {
            this.get_admin_data(this.tabs[val].content)
        }
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        groupedWallets() {
            if (!this.wallets || !this.wallets.length) return []

            // Группируем кошельки по числовому полю group и сохраняем порядок групп.
            const groups = this.wallets.reduce((acc, wallet) => {
                const group = Number(wallet.group)

                if (!acc[group]) {
                    acc[group] = {
                        group,
                        items: [],
                        total: new BigNumber(0)
                    }
                }

                acc[group].items.push(wallet)

                for (const account of wallet.account_details || []) {
                    if (!account || account.balance == null) continue

                    acc[group].total = acc[group].total.plus(account.balance)
                }

                return acc
            }, {})

            return Object.values(groups).sort((a, b) => a.group - b.group)
        }
    },
    methods: {
        ...mapActions(['UpdateHeader', 'ActionGetAdminWallets']),
        isUserInGroup: function (type) { 
            return this.helper.isUserInGroup(type, this.$store.getters.StateGroups)
        },
        getStatusLabel (status) {
            return this.helper.get_severity_status(status, 'RU')
        },
        get_format_amount(value, currency, digits = 0) {
            return this.helper.format_amount(value, currency, digits)
        },
        getGroupTotal(group) {
            const total = this.get_format_amount(group.total.toString(), null)
            return `${this.lang === 'ru' ? 'Итого' : 'Total'}: ${total} USDT`
        },
        showMess(severity, summary, detail) {
            this.$toast.add({severity: severity, summary: summary, detail: detail, life: 3000});
        },
        toWallet(id){
            if(!id) return
            this.$router.push({path: `/admin/wallet/${id}`})
        },
        getCurImage(code){
            return this.helper.GetCurrencyImage(code, this.currencies)
        },
        GetWalletNameByLabel(label){
            return this.helper.GetWalletNameByLabel(label)
        },
        GetClassByLabel(label){
            return this.helper.GetClassByLabel(label)
        },
        getNetworkImage(network) {
            if(!network) return null
           return this.helper.GetNetworkImage(network)
        },
        updateHeader() {
            this.UpdateHeader({
                title: this.header[this.lang].title,
                backButton: true,
                backButtonUrl: '/admin/',
                profileButton: false
            });
        },
        async GetWallets(){
            this.loading = true
            try { 
                const resWallets = await this.$store.dispatch('ActionGetAdminWallets')
                if(resWallets) {
                    // отсортируем по ext_sort 
                    this.wallets = resWallets.sort((a, b) => a.ext_sort - b.ext_sort)
                }
            } catch { console.log('error store get wallets')}
            this.loading = false
        },
        getCurrencyList(){
            const objList = this.$store.state.payment.currencies
            if(!objList)return
            let currencies = []
            for(const [k,v] of Object.entries(objList)){
                currencies.push({
                    code: v.code,
                    name: k.toUpperCase(),
                    image: v.image
                })
            }
            this.currencies = currencies
        },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    mounted() {
        this.getCurrencyList()
        this.GetWallets()
        this.helper.SetTgAppBackButton(false)
        this.updateHeader()
    }
}
</script>